(function($) {
  
    $(document).ready(function() {
        
    });
  
})(jQuery);

function initCardEvent(){
    var $ = jQuery;
    /*$(window).on('resize',function(){
        $('.m-card-event .text').css('height','auto');
        var height = 0;
        $('.m-card-event .text').each(function(){
            if($(this).outerHeight() > height){
                height = $(this).outerHeight();
            }
        })
        $('.m-card-event .text').css('height',height);
    }).trigger('resize')*/
}